import type { ReactNode } from "react";
import { useTranslation } from "react-i18next";
import { useDirection } from "../i18n";
import { Button } from "./Button";
import "./motion.css";
import "./screen.css";

export interface ScreenProps {
  readonly title?: string;
  readonly onBack?: () => void;
  readonly actions?: ReactNode;
  readonly children: ReactNode;
  readonly center?: boolean;
}

export function Screen({
  title,
  onBack,
  actions,
  children,
  center = false,
}: ScreenProps) {
  const { t } = useTranslation();
  const direction = useDirection();
  const backIcon = direction === "rtl" ? "→" : "←";

  return (
    <section className="screen motion-fade">
      {(title || onBack || actions) && (
        <header className="screen__header">
          {onBack ? (
            <Button
              label={t("common.back")}
              icon={backIcon}
              variant="secondary"
              size="sm"
              onClick={onBack}
            />
          ) : null}
          {title ? <h1 className="screen__title">{title}</h1> : null}
          {actions ? <div className="screen__actions">{actions}</div> : null}
        </header>
      )}
      <div
        className={`screen__content${center ? " screen__content--center" : ""}`}
      >
        {children}
      </div>
    </section>
  );
}
